import { useQuery } from '@apollo/client/react';
import { GET_VENDOR_CATALOG } from 'api/graphql/catalog';
import { useVendor } from 'features/vendor';

/** Fetches the active vendor's catalog items. */
export function useVendorCatalog() {
  const { vendorId, loading: vendorLoading } = useVendor();

  const { data, loading, error, refetch, networkStatus } = useQuery(GET_VENDOR_CATALOG, {
    variables: { vendorId },
    skip: !vendorId,
    notifyOnNetworkStatusChange: true,
  });

  return {
    items: data?.getVendorCatalog ?? [],
    // Treat "still resolving the vendor id" as loading so consumers don't flash
    // an empty state before the catalog query can even run.
    loading: vendorLoading || loading,
    error,
    refetch,
    isRefetching: networkStatus === 4,
    vendorId,
  };
}
